import { Box, Paper, useMediaQuery, useTheme } from '@material-ui/core';
import React, { useEffect } from 'react';
import Conversation from '../Conversation';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import Dialog from '@material-ui/core/Dialog';
import ProductDetailsActions from 'scenes/ProductDetails_page/store/actions';
import { useDispatch } from 'react-redux';
import socket from 'providers/SocketioProvider/chat';

interface IChatBoxProps {
  size?: {
    width?: number;
    height?: number;
  };
  chatgroupId: string;
  open: boolean;
  onClose: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ChatBox = ({
  chatgroupId,
  open,
  size,
  onClose,
}: IChatBoxProps) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  const conversation = (
    <Conversation
      chatgroupId={chatgroupId}
      open={open}
      onClose={onClose}
      containerProps={{
        style: {
          background: 'white',
          height: matches ? '100%' : size?.height ?? 500,
        },
      }}
    />
  );

  if (matches) {
    return (
      <Dialog
        open={true}
        onClose={onClose}
        TransitionComponent={Transition}
        fullScreen
        style={{ marginTop: 50 }}
      >
        <Box
          style={{
            boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
            height: '100%',
          }}
        >
          {conversation}
        </Box>
      </Dialog>
    );
  }

  return (
    <Box
      style={{
        width: size?.width ?? 400,
        boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
        zIndex: 999000000,
        height: '100%',
      }}
    >
      {conversation}
    </Box>
  );
};
export default ChatBox;

interface ICollapsingChatBoxProps {
  size?: {
    width?: number;
    height?: number;
  };
  chatgroupId: string;
  right?: number | string;
}
export const CollapsingChatBox = ({
  chatgroupId,
  size,
  right,
}: ICollapsingChatBoxProps) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    const convStartEvent = 'conversation.start';
    const convStartAction = (message: any[]) => {
      setOpen(true);
    };

    socket.on(convStartEvent, convStartAction);
    return () => {
      socket.removeListener(convStartEvent, convStartAction);
    };
  }, [socket.connected]);

  const conversation = (
    <Conversation
      chatgroupId={chatgroupId}
      open={open}
      onOpen={(e) => {
        setOpen(true);
        // console.log('true');
      }}
      onClose={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(false);
      }}
      containerProps={{
        style: {
          background: 'white',
          height: open ? (matches ? '100%' : size?.height ?? 500) : '50px',
          transition: 'height 350ms ease-out',
          // width:
        },
      }}
    />
  );

  if (open && matches) {
    return (
      <Dialog
        open={true}
        onClose={() => {
          setOpen(false);
        }}
        TransitionComponent={Transition}
        fullScreen
        style={{ marginTop: 50, bottom: 0 }}
      >
        <Box
          style={{
            boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
            height: '100%',
          }}
        >
          {conversation}
        </Box>
      </Dialog>
    );
  }

  return (
    <Box
      style={{
        width: size?.width ?? 300,
        boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
        zIndex: 999000000,
        height: '100%',
      }}
    >
      {conversation}
    </Box>
  );
};
